import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";

const contractRouters: RouteRecordRaw[] = [
    {
        path: "/contract",
        name: "ContractManagement",
        meta: { title: "合同管理" },
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/contract",
        children: [
            {
                path: "/contract",
                name: "Contract",
                meta: {
                    title: "合同管理",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "ContractManagement",
                    pageType: PAGE_TYPE.LIST.code,
                    keepAlive: true
                },
                component: () => import("@/views/pages/contractManagement/index.vue")
            },
            {
                path: "/contract/contractDetail",
                name: "ContractDetail",
                meta: { title: "合同详情", hidden: true, activeMenu: "ContractManagement" },
                component: () => import("@/views/pages/contractManagement/detail.vue")
            }
        ]
    }
];

export default contractRouters;
